import React from 'react';
import PropTypes from 'prop-types';
import Obfuscate from 'react-obfuscate';
import MuiLink from '@mui/material/Link';
// eslint-disable-next-line camelcase
import { unstable_styleFunctionSx } from '@mui/system';
import { styled } from '@mui/material/styles';
import { sxPropType } from '../../proptypes/misc';

const StyledObfuscate = styled(Obfuscate)(unstable_styleFunctionSx);

function ExternalLink({ sx, href, children, isMagenta, ...other }) {
  console.log(isMagenta);
  const isMail = href.includes('@');

  return isMail ? (
    <StyledObfuscate
      email={href}
      sx={[
        (theme) => ({
          color: `${isMagenta ? theme.palette.link.primary : theme.palette.link.secondary} !important`,
          textDecoration: 'none',
          '&:focus, &:hover': {
            textDecoration: 'underline',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  ) : (
    <MuiLink
      href={href}
      sx={[
        (theme) => ({ color: isMagenta ? theme.palette.link.primary : theme.palette.link.secondary }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {children}
    </MuiLink>
  );
}

ExternalLink.propTypes = {
  sx: sxPropType,
  href: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isMagenta: PropTypes.bool.isRequired,
};

ExternalLink.defaultProps = {
  sx: [],
};

export default ExternalLink;
